// extracted by mini-css-extract-plugin
export default {"ctn":"QuizBanner_ctn__DeKUq","main":"QuizBanner_main__uwKvz","footer":"QuizBanner_footer__oH9B4","result":"QuizBanner_result__N39d9","btn":"QuizBanner_btn__pw8jP"};